import { Component, OnInit, Input } from '@angular/core';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { PlanCompensatorioTurnosModel } from 'src/app/models/PlanCompensatorioTurnos.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UtilService } from 'src/app/shared/services/util.service';
declare var $;

@Component({
  selector: 'app-informacion-turno',
  templateUrl: './informacion-turno.component.html',
  styleUrls: ['./../plan-compensatorio.component.scss']
})
export class InformacionTurnoComponent implements OnInit {

  @Input() infoTurnos: PlanCompensatorioModel;
  public placeholderDate: string;
  public consultaEstados: string[];
  public fechasMinimas: Date[] = [];

  constructor(
    private spinner: NgxSpinnerService,
    private urlService: UrlService,
    private global: GlobalService,
    private alertService: AlertService,
    private util: UtilService
  ) {
  }

  ngOnInit() {
    this.obtenerEstados();
    this.placeholderDate = ConstantesService.SELECCION_FECHA;
    if (this.infoTurnos.listaTurnos[0]) {
      $('#nombrePrimerTurno').val(this.infoTurnos.listaTurnos[0].nombre);
    }
    if (this.infoTurnos.listaTurnos[1]) {
      $('#nombreSegundoTurno').val(this.infoTurnos.listaTurnos[1].nombre);
    }
    if (this.infoTurnos.listaTurnos[2]) {
      $('#nombreTercerTurno').val(this.infoTurnos.listaTurnos[2].nombre);
    }
    if (this.infoTurnos.listaTurnos.length === 0) {
      for (let index = 0; index < 3; index++) {
        this.infoTurnos.listaTurnos[index] = new PlanCompensatorioTurnosModel();
        this.infoTurnos.listaTurnos[index].estado = index === 0 ?
          DominiosService.TURNO_COMPENSACION_ACTIVO : DominiosService.TURNO_COMPENSACION_INACTIVO;
      }
    } else {
      this.infoTurnos.listaTurnos.forEach((turno, index) => {
        this.fechasMinimas[index] = this.obtenerFechaMinima(turno.fechaInicial);
      })
    }
  }

  /**
   * Consulta los tipo de estado Existente
   */
  public obtenerEstados() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'EstadoTurnoCompensatorio']);
    const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_FUNCIONARIOS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.consultaEstados = data;
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible Obtener los Estados');
      }
    );
  }

  /**
   * Metodo que realiza el cambio de nombre seleccionado y ubicandolo en la posicion correcta
   * a la que se requiere modificar
   * @param index posicion
   * @param nombre nombre por el que se cambiara
   */
  actualizarNombre(index: number, nombre: string) {
    this.infoTurnos.listaTurnos[index].nombre = nombre;
  }

  /**
   * Método de control de Excepciones
   * @param error mensaje saliente respecto al error ocurrido
   */
  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }

  /**
   * Método que obtiene la fecha siguiente dependiendo una fecha dada
   * que puede ser un {@type Date} o un {@type string} con un formato valido de fecha
   * @param fecha fecha a utilizar
   * @returns Date fecha menos un dia o undefined si se presenta un error durante la operacion
   */
  obtenerFechaMinima(fecha: Date | string): Date {
    return this.util.fromStringToDate(fecha, true);
  }

  /**
   * Método que actualiza a la fecha final del turno que recibe por parametro
   * @param event nueva fecha inicial del turno
   * @param posicion turno sobre el que se trabaja
   */
  actualizarFechaFinal(event: any, posicion: number) {
    this.infoTurnos.listaTurnos[posicion].fechaInicial = event;
    this.fechasMinimas[posicion] = this.obtenerFechaMinima(event);
  }
}
